<template>
    <div class="padlock-prompt">
        <p style="text-align:center"><i class="pi pi-unlock" style="font-size: 36px;color:var(--primary-color)"></i></p>
        <p class="booking__headline">{{ dictionary.PadlockPromptHeadline }}</p>
        <p>{{ dictionary.PadlockPromptText }}</p>
        <Button :label="acceptButtonLabel" class="p-button-rounded" @click="handleAction(true)"></Button>
        <Button :label="declineButtonLabel" class="p-button-secondary p-button-rounded p-button-outlined" @click="handleAction(false)"></Button>
    </div>
</template>
<script>
import Button from "primevue/button";

export default {
    name: "padlockPrompt",
    inject: ['dialogRef'],
    components: {
        Button
    },
    data() {
        return {
            dictionary: {},
            roomId: null,
            padlockPrice: null,
            acceptButtonLabel:"",
            declineButtonLabel:""
        };
    },
    created() {
        const vm = this;
        vm.roomId = vm.dialogRef.data.roomId;
        vm.padlockPrice = vm.dialogRef.data.padlockPrice;
        fetch("/umbraco/api/dictionaryapi/GetPadlockPromptDictionary").then((response) => response.json())
            .then((data) => {
                vm.dictionary = data;
                vm.acceptButtonLabel = data.PadlockPromptAccept.replace("{padlockPrice}",vm.padlockPrice);
                vm.declineButtonLabel = data.PadlockPromptDecline;
            })
            .catch((error) => {
                console.log(error);
            });
    },
    methods: {
        handleAction(acceptPadlock) {
            this.dialogRef.close({acceptPadlock:acceptPadlock});
        }
    }
};
</script>
